module.exports = "<div *ngIf=\"!!home\" class=\"home\">\n    <div class=\"leftPanel\" *ngIf=\"!!home.showPicture\">\n        <img src=\"assets/img/me.jpg\" class=\"photo\">\n        <span>{{home.name}}</span>\n        <a *ngIf=\"!!home.linkedIn\" [href]=\"home.linkedIn\" class=\"linkedIn\">\n            <img src=\"assets/img/linkedin.png\" class=\"linkedInLogo\">\n        </a>\n    </div>\n    <div class=\"rightPanel\">        \n        <h1>{{home.title}}</h1>\n        <p *ngFor=\"let text of home.text\">{{text}}</p>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/thunder/git/portfolier/src/app/home/home.html
// module id = ../../../../../src/app/home/home.html
// module chunks = 1